import { render, staticRenderFns } from "./SntBubble.vue?vue&type=template&id=78c72a92&scoped=true&"
import script from "./SntBubble.vue?vue&type=script&lang=js&"
export * from "./SntBubble.vue?vue&type=script&lang=js&"
import style0 from "./SntBubble.vue?vue&type=style&index=0&id=78c72a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c72a92",
  null
  
)

export default component.exports